const dropdowns = document.querySelectorAll('.monthly-reports .dropdown__inner');

dropdowns.forEach((el) => {
	const inputs = el.querySelectorAll('input');
	inputs.forEach(item => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			axios
				.post(localData.siteURL, { action: 'getReportsByYear', keyword: e.target.value }, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then((response) => {
					const searchResultInner = el.closest('.monthly-reports').querySelector('.monthly-reports__inner');
					searchResultInner.innerHTML = response.data.data;
				});
		});
	});
});
